import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CatalogCategoryData } from '../models/api-models';
import { getReportTemplateCatalog, isReportTemplateCatalogLoading } from '../store/settings/selectors';
import { loadReportTemplateCatalog } from '../store/settings/actions';

export interface ReportTemplateCatalogHook {
    catalog: CatalogCategoryData[];
    loading: boolean;
}

export const useReportTemplateCatalog = (): ReportTemplateCatalogHook => {
    const dispatch = useDispatch();
    const catalog = useSelector(getReportTemplateCatalog) ?? [];
    const loading = useSelector(isReportTemplateCatalogLoading);

    useEffect(() => {
        dispatch(loadReportTemplateCatalog());
    }, [dispatch]);

    return { catalog, loading };
};
